import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-deduction',
  templateUrl: './deduction.component.html',
  styleUrls: ['./deduction.component.scss']
})
export class DeductionComponent implements OnInit {
  button = {}
  TypeValue: any;
  private handleError: HandleError;
  TaxableStatus: {};
  InsuranceStatus: {}
  customDataSource: any;
  type: number;
  date = new Date()
  addpopup: string = '';
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;

  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public gt: genericCustomStoreService
    , private validation: CheckValidation, public Objects: ObjectsService, public translate: TranslateService) {
    gt.seturl("DeductType");
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY);
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.TypeValue = Objects.TypeValue;
    this.TaxableStatus = Objects.TaxableStatus
    this.InsuranceStatus = Objects.InsuranceStatus
    this.button = Objects.button;

    this.validateAsync = this.validateAsync.bind(this);
    this.validateAsyncForEn = this.validateAsyncForEn.bind(this)

    this.setCellValuetypevalue = this.setCellValuetypevalue.bind(this);
  }
  ngOnInit(): void {
  }
  validateAsync(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "DeductType");
  }
  validateAsyncForEn(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "DeductType", 'CheckName', 'NameEn');
  }


  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
    options.newData.dateOfRegistration = this.date
  }
  onInitNewRow(e: any) {
    e.data.dateOfRegistration = this.date
    this.addpopup = this.translate.instant('tableinfo.addbutton')
  }
  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }
  onEditorPreparing(e: any) {
    this.gt.onEditorPreparing(e)
  }
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }
  setCellValuetypevalue(newData: any, value: any) {
    newData.valueType = value
    this.type = value
  }

}
